import { accordionItemStyles as fastAccordionItemStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationAccordionItemStyles = (context, definition) => css `
  ${fastAccordionItemStyles(context, definition)}

  slot[name='collapsed-icon'] {
    display: flex;
    stroke: var(--accent-foreground-rest);
    fill: none;
  }

  slot[name='expanded-icon'] {
    display: none;
    stroke: var(--accent-foreground-rest);
    fill: none;
  }
`;
